import { useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';

import { useGetCurrentGantt } from 'src/hooks/gantts/get-current-gantt.hook';

export const GET_HOLIDAY_SUBGROUP_BY_LOCATION_ID = gql`
  query getHolidaySubGroupsByLocationId($holidayLocationId: String!) {
    getHolidaySubGroupsByLocationId(holidayLocationId: $holidayLocationId) {
      _id
      holidays {
        name
        dateFrom
        dateTo
      }
    }
  }
`;

export const HOLIDAY_SUBGROUP_CHANGED_SUBSCRIPTION = gql`
  subscription holidaySubGroupsChanged($holidayLocationId: String!) {
    holidaySubGroupsChanged(holidayLocationId: $holidayLocationId) {
      trigger
      holidaySubGroup {
        _id
        holidays {
          name
          dateFrom
          dateTo
        }
      }
    }
  }
`;

export const useGetHolidaySubgroupsForGantt = () => {
  const {
    gantt: { holidayLocationId },
  } = useGetCurrentGantt();
  const { data, loading, subscribeToMore } = useQuery(GET_HOLIDAY_SUBGROUP_BY_LOCATION_ID, {
    variables: { holidayLocationId },
    skip: !holidayLocationId,
  });
  const holidaySubGroups = data?.getHolidaySubGroupsByLocationId || [];

  useEffect(() => {
    holidayLocationId &&
      subscribeToMore({
        document: HOLIDAY_SUBGROUP_CHANGED_SUBSCRIPTION,
        variables: { holidayLocationId },
        updateQuery: (prev, { subscriptionData }) => {
          if (!subscriptionData.data) return prev;

          const { trigger, holidaySubGroup } = subscriptionData.data?.holidaySubGroupsChanged || {};
          const groups = prev?.getHolidaySubGroupsByLocationId || [];
          const newHolidaySubGroups = [...groups];
          const findIndex = groups.findIndex((value: any) => value._id === holidaySubGroup._id);

          if (trigger === 'holidaySubgroupCreated' && findIndex < 0) {
            newHolidaySubGroups.push(holidaySubGroup);
          }

          if (findIndex > -1) {
            if (trigger === 'holidaySubgroupRemoved') {
              newHolidaySubGroups.splice(findIndex, 1);
            }

            if (trigger === 'holidaySubgroupUpdated') {
              newHolidaySubGroups[findIndex] = holidaySubGroup;
            }
          }

          return { getHolidaySubGroupsByLocationId: newHolidaySubGroups };
        },
      });
  }, [subscribeToMore, holidayLocationId]);

  return { loading, holidaySubGroups };
};
